(() => {
  function initLpNav() {
    const toggle = document.getElementById('trigger2605_nav_toggle');
    const drawer = document.getElementById('trigger2605_nav_drawer');
    if (!toggle || !drawer || toggle.dataset.lpNavBound === 'true') return;
    toggle.dataset.lpNavBound = 'true';

    const root = toggle.closest('.trigger2605');
    const backdrop = drawer.querySelector('.trigger2605_nav_drawer__backdrop');

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      drawer.classList.toggle('trigger2605_nav_drawer--open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      root?.classList.toggle('trigger2605--nav-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    backdrop?.addEventListener('click', () => setOpen(false));

    drawer.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!drawer.classList.contains('trigger2605_nav_drawer--open')) return;
      setOpen(false);
    });
  }

  const SELECTOR = '.trigger2605_care_video__item';
  const BP = window.matchMedia('(max-width: 768px)');
  const SLIDE_SELECTOR = '.trigger2605_care_video__slide, .embla__slide';
  const emblaMap = new Map();

  function getParts(root) {
    return {
      viewport: root.querySelector('.trigger2605_care_video__viewport'),
      container: root.querySelector('.trigger2605_care_video__container'),
      prev: root.querySelector('.embla__prev'),
      next: root.querySelector('.embla__next'),
      slides: root.querySelectorAll(SLIDE_SELECTOR),
    };
  }

  function bindButtons(embla, prev, next) {
    if (!prev || !next) return;
    const onPrev = () => embla.scrollPrev();
    const onNext = () => embla.scrollNext();
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);

    const update = () => {
      prev.disabled = !embla.canScrollPrev();
      next.disabled = !embla.canScrollNext();
    };
    embla.on('select', update);
    embla.on('reInit', update);
    update();

    return () => {
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
    };
  }

  function mount(root) {
    const { viewport, container, prev, next, slides } = getParts(root);
    if (!viewport || !container || slides.length < 2) return;

    // Embla が未読込なら何もしない
    if (typeof window.EmblaCarousel !== 'function') return;

    const embla = window.EmblaCarousel(viewport, {
      align: BP.matches ? 'center' : 'start',
      loop: BP.matches,
      dragFree: false,
      watchDrag: true,
      containScroll: BP.matches ? false : 'trimSnaps',
    });

    const cleanupButtons = bindButtons(embla, prev, next);

    emblaMap.set(root, {
      embla,
      cleanup: () => {
        if (cleanupButtons) cleanupButtons();
        embla.destroy();
      },
    });
  }

  function unmount(root) {
    const state = emblaMap.get(root);
    if (!state) return;
    state.cleanup();
    emblaMap.delete(root);
  }

  function remountAll() {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      unmount(root);
      mount(root);
    });
  }

  function initCarousel() {
    if (typeof window.EmblaCarousel !== 'function') {
      window.addEventListener('load', initCarousel, { once: true });
      return;
    }

    document.querySelectorAll(SELECTOR).forEach(mount);

    // breakpoint を跨いだら loop 設定を反映し直す
    if (BP.addEventListener) {
      BP.addEventListener('change', remountAll);
    } else {
      BP.addListener(remountAll);
    }

    window.addEventListener('resize', (() => {
      let t = null;
      return () => {
        if (t) cancelAnimationFrame(t);
        t = requestAnimationFrame(() => {
          // 幅変化でレイアウトが崩れたときの再初期化
          emblaMap.forEach(({ embla }) => embla.reInit({ loop: BP.matches }));
        });
      };
    })());
  }

  function boot() {
    initLpNav();
    initCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();